export interface DashboardFilter {
  userId: number;
  departmentId: number;
  timelineType: any;
}

export enum TimelineType {
  AllTime = 'AllTime',
  Today = 'Today',
  Week = 'Week',
  Month = 'Month',
}

export const InitialDashboardFilter = {
  userId: null,
  departmentId: null,
  timelineType: TimelineType.AllTime,
};
